import { FaCalendarDays, FaComments, FaClipboardList } from "react-icons/fa6";

const About = {
    sub: "適合所有人的機器人競賽",
    heading: "透過 WRG® 機器人競賽，以科學、技術與教育培養知識。",
    description:[
        "2025 年是一個令人振奮的年份，隨著邊緣 AI 運算的成熟，開啟了我們機器人技術發展的新篇章。從今年開始，我們預期會將更多邊緣 AI 的能力與創新的機器人技術融入 WRG 競賽。2025 年，將真正成為 AI 機器人技術的元年。\n\n",
        "隨著邊緣 AI 運算能力的提升，機器人能夠具備更強大的感知與控制能力。透過部署在地化的大型語言模型，機器人即使不依賴雲端 AI，也能在離線環境中高效運作，完成更複雜的任務。曾經夢幻般的 AI 機器人願景，如今正一步步成為現實。",
        "在 2025 年的競賽中，我們以 AI 機器人為藍圖，來呈現我們對未來的願景。在 WRG，我們設計了創新的競賽項目，將實體機器人、韌體、軟體以及多種 AI 技術結合，打造更聰明、更靈活的機器人系統。這些系統將參與各種創意應用，展現一個更加光明的未來藍圖。"
    ],
    points: [
        // { icon: <FaCalendarDays />, title: "交流機會" },
        // { icon: <FaComments />, title: "專家演講" },
        // { icon: <FaCalendarDays />, title: "定期聚會" },
        // { icon: <FaClipboardList />, title: "資源分享" }
    ],
    button: {
        text: "註冊",
        link: "https://forms.gle/Mn89fLtedYEhpmw28"
    }
};

export default About;
